export default "__VITE_ASSET__D16Iy7Ds__"